import React from 'react';
import { Link } from 'react-router-dom';
import S from './style'
import TranslateStatic from '../../locales/TranslateStatic';

import Gen1 from '../../assets/genetiktarama/1.jpeg'
import Gen2 from '../../assets/genetiktarama/2.jpeg'
import Gen3 from '../../assets/genetiktarama/3.jpeg'
import Gen4 from '../../assets/genetiktarama/4.jpeg'
import AsrmEshre from '../../components/asrmEshre';

export function GenetikTarama() {
  return (
    <S.PageWrapper>
      <S.HeroSection>
        <div className="hero-content">
          <h1><TranslateStatic string="genetik tarama" /></h1>
          <h2 className="subtitle"><TranslateStatic string="genetik tarama2" /></h2>
          <S.Breadcrumb>
            <Link to="/"><TranslateStatic string="home" /></Link>
            <span className="separator">/</span>
            <TranslateStatic string="genetik tarama" />
          </S.Breadcrumb>
        </div>
      </S.HeroSection>

      <S.ContentWrapper>
        <div className="info-container">
          <div className="images-grid">
            <div className='imgwrap'>
              <span>1</span>
              <img src={Gen1} alt="Genetik Tarama 1" />
            </div>
            <div className='imgwrap'>
              <span>2</span>
              <img src={Gen2} alt="Genetik Tarama 2" />
            </div>
            <div className='imgwrap'>
              <span>3</span>
              <img src={Gen3} alt="Genetik Tarama 3" />
            </div>
            <div className='imgwrap'>
              <span>4</span>
              <img src={Gen4} alt="Genetik Tarama 4" />
            </div>
          </div>
          <div className="image-note">Görüntüler Gelecek Tüp Bebek merkezine aittir.</div>

          <div className="date-info">
            <TranslateStatic string="SonGuncellemeTarihi" /> 19.02.2025
          </div>

          <div className="text-content">
            <p>
              <TranslateStatic string="genetikTaramaUsP1" />
            </p>
            <h3><TranslateStatic string="genetikTaramaUsh3-1" /></h3>
            <p>
              <TranslateStatic string="genetikTaramaUsP2" />
            </p>
            <h3><TranslateStatic string="genetikTaramaUsh3-2" /></h3>
            <p>
              <TranslateStatic string="genetikTaramaUsP3" />
            </p>
            <p>
              <TranslateStatic string="genetikTaramaUsP3-1" />
            </p>
            <h3><TranslateStatic string="genetikTaramaUsh4-1" /></h3>
            <p>
              <TranslateStatic string="genetikTaramaUsP4-1" />
            </p>
            <p>
              <TranslateStatic string="genetikTaramaUsP4-2" />
            </p>
            <p>
              <TranslateStatic string="genetikTaramaUsP4-3" />
            </p>
          </div>
        </div>

        <AsrmEshre />
      </S.ContentWrapper>
    </S.PageWrapper>
  );
}
